/// <reference path="../../../../components/common/payroll.service.ts" />
/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.QuickbooksDesktop {

    interface IAccountQueueRequest {
        criteria?: any;
        itemsPerPage: number;
        clientGlobalId?: string;
        asLocationId?: number;
        sortBy?: string;
        sortDirection?: Model.SortDirection
    }

    interface IParams {
        dateTo: Date | string,
        dateFrom: Date | string,
        processingStatuses: Array<any>,
        applicationConnectionId: string,
    }

    class QuickbooksDesktopQueueComponent implements angular.IComponentController {

        static $inject = [
            'meevo.plugins.quickbooksDesktop.QuickbooksDesktopApi',
            '$translate',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            '$scope',
        ];

        public arrayResults: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;

        public request: IAccountQueueRequest = {
            criteria: this.defaultParams,
            itemsPerPage: 25,
            sortBy: 'dateCreated',
            sortDirection: Model.SortDirection.Descending
        };

        constructor(
            private apiService: QuickbooksDesktop.IQuickbooksDesktopApi,
            private $translate: angular.translate.ITranslateService,
            private dataService: Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private $scope: angular.IScope,) {
        }

        $onInit() {
            this.getQueueList();
            this.$scope.$on('selectQueueTab', this.getQueueList.bind(this));
        }

        /**
         * Paged Object of results
         * @param {string} url
         * @param {Function} onPageLoad
         */
        getResults(url: string, onPageLoad: Function) {
            return new Meevo.Components.BaseClasses.PagedResults(this.dataService, url, onPageLoad, this);
        }

        /**
        * Load List of Queues
        */
        getQueueList(): void {
            let request: any = angular.copy(this.request),
                url: string = 'AccountSyncDesktop/Queue';

            this.busyService.start();
            this.arrayResults = this.getResults(url, this.prepareData);
            this.arrayResults.initSearch(request);
        }

        /**
         * Map loaded data
         * */
        prepareData(pageNumber, items, context): void {
            //Add property isSelected to list of queues for selecting item
            items.forEach((queue: IQueue) => queue.isSelected = false);
            context.busyService.stop();
        }

        /**
         * Handler for selecting all queues
         * */
        selectAllQueue():void {
            (<any>this.arrayResults).loadedPages.forEach((page: Array<IQueue>) => {
                page.forEach((queue: IQueue) => queue.isSelected = true)
            });
        }

        /**
         * Prepare and delete queue records
         * */
        deleteSelectedQueue() {
            this.modalService.warning(
                'LABEL_QUEUE_DELETE_MODAL',
                Meevo.Components.Modal.ModalTranslationModes.Translate,
                false,
                {
                    showCancelButton: true,
                    cancelButtonContentKey: 'LABEL_NO',
                    cancelButtonHotKey: 'MODAL_NO_BUTTON',
                    okButtonHotKey: 'MODAL_YES_BUTTON',
                    okButtonContentKey: 'LABEL_YES'
                }
            ).then((result: boolean) => {
                this.busyService.start();

                const queuesToDelete: Array<IQueueDelete> = this.arrayResults.getAllItems()
                    .filter((queue: IQueue) => queue.isSelected)
                    .map(({ accountSyncQueueHeaderId, applicationConnectionId }: IQueue): IQueueDelete => {
                        return {
                            accountSyncQueueHeaderId,
                            applicationConnectionId
                        }
                    });
                
                return this.apiService.deleteQueue({ items: queuesToDelete })
            }).then(_=> {
                this.getQueueList();
            }).finally(() => this.busyService.stop());
        }

        /**
         * Check if we have selected queue item
         * */
        get isButtonDisabled(): boolean {
            return this.arrayResults.getAllItems().some((queue: IQueue) => queue && queue.isSelected);
        }

        get isQueueEmpty(): boolean {
            return !this.arrayResults.getLength();
        }

        get syncActionTypeEnum() {
            return SyncActionTypeEnum;
        }

        get defaultParams(): IParams {
            return {
                dateFrom: '',
                dateTo: '',
                processingStatuses: [SyncProcessingStatusEnum.NotProcessed],
                applicationConnectionId: '',
            }
        }

    }

    angular.module('meevo.plugins.quickbooksDesktop')
        .component('quickbooksDesktopQueueComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/quickbooksDesktop/components/queue/queue.component.html',
            controller: QuickbooksDesktopQueueComponent,
            controllerAs: '$ctrl',
            bindings: {}
        });
}
